module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Globe-1da3e71888951fd921a51db0780fe835.svg";